<div class="assistant-chat">
  <div class="chat-thread" #thread aria-live="polite" aria-atomic="false">
    <!-- Empty state -->
    <div class="chat-empty" *ngIf="!messages.length && !isSending" role="status">
      <span class="chat-empty__orb" aria-hidden="true">
        <ion-icon name="sparkles" *ngIf="!isHistoryLoading"></ion-icon>
        <span class="chat-empty__dots" *ngIf="isHistoryLoading" aria-hidden="true">
          <i></i><i></i><i></i>
        </span>
      </span>
      <p class="chat-empty__title" *ngIf="isEmptyLoading || !welcomeGreeting">{{ emptyTitleKey | translate }}</p>

      <!-- Agent-composed greeting. Takes the title's place once it lands. -->
      <p
        class="chat-empty__greeting"
        *ngIf="!isEmptyLoading && welcomeGreeting"
        [innerHTML]="welcomeGreeting | novaMarkdown">
      </p>

      <p class="chat-empty__hint" *ngIf="!isHistoryLoading && !welcome">{{ 'NOVA_EMPTY_HINT' | translate }}</p>

      <!-- Starter pills. Held back while either wait is in progress: onChatSend drops a
           send until the harness settles, so an early tap would vanish silently. -->
      <card-actions
        *ngIf="!isEmptyLoading && welcomeActions.length"
        class="chat-empty__actions"
        [actions]="welcomeActions"
        (action)="action.emit($event)">
      </card-actions>

      <!-- Placeholder prompts where the agent's prompts will appear: while the welcome turn runs, and
           while more are fetched past the end of the pool. -->
      <div
        class="chat-empty__skeleton"
        *ngIf="showsPromptPlaceholders"
        [attr.aria-label]="(isAwaitingMoreIdeas ? 'NOVA_LOADING_MORE_IDEAS' : 'LOADING') | translate">
        <span class="chat-empty__skeleton-pill" *ngFor="let w of skeletonWidths" [style.width.px]="w"></span>
      </div>

      <button
        type="button"
        class="chat-empty__more"
        *ngIf="!isEmptyLoading && hasMoreWelcomeIdeas"
        [disabled]="isAwaitingMoreIdeas"
        (click)="onMoreIdeas()">
        <ion-icon name="refresh-outline" aria-hidden="true"></ion-icon>
        <span>{{ (isAwaitingMoreIdeas ? 'NOVA_FINDING_MORE_IDEAS' : 'NOVA_MORE_IDEAS') | translate }}</span>
      </button>
    </div>

    <!-- Skeleton row when history is loading on top of existing messages — e.g.
         reopening Discuss with a longer thread the server is still streaming back. -->
    <div class="chat-msg nova chat-loading" *ngIf="isHistoryLoading && messages.length" [attr.aria-label]="'NOVA_LOADING_EARLIER_MESSAGES' | translate">
      <div class="msg-avatar" aria-hidden="true"><ion-icon name="sparkles"></ion-icon></div>
      <div class="msg-bubble typing" aria-hidden="true">
        <span></span><span></span><span></span>
      </div>
    </div>

    <!-- Messages -->
    <div
      *ngFor="let m of messages"
      class="chat-msg"
      [class.user]="m.role === 'user'"
      [class.nova]="m.role !== 'user'">
      <div class="msg-avatar" *ngIf="m.role !== 'user'" aria-hidden="true">
        <ion-icon name="sparkles"></ion-icon>
      </div>
      <div class="msg-content">
        <!-- User turn: plain bubble with attachment pills. -->
        <div
          class="msg-bubble"
          *ngIf="m.role === 'user'"
          [attr.aria-label]="'NOVA_USER_MESSAGE_LABEL' | translate: { text: m.text }">
          <div class="msg-attachments" *ngIf="m.attachments?.length">
            <span
              class="msg-attach-chip"
              *ngFor="let a of m.attachments">
              <ion-icon
                [name]="a.kind === 'meeting' ? 'sparkles-outline'
                       : a.kind === 'transcript' ? 'document-text-outline'
                       : a.kind === 'account' ? 'business-outline'
                       : 'person-circle-outline'"
                aria-hidden="true">
              </ion-icon>
              {{ a.label }}
            </span>
          </div>
          <p *ngIf="m.text | novaSlash as parts"><span class="msg-slash" *ngIf="parts.command">{{ parts.command }}</span>{{ parts.rest }}</p>
        </div>

        <!-- Assistant turn: rendered entirely as a unified card.
             Action chips are gated to the latest turn only — stale chips on
             earlier turns would re-run prompts that are no longer relevant. -->
        <nova-card
          *ngIf="m.role !== 'user'"
          class="msg-card"
          [attr.aria-label]="'Ask-Nova: ' + m.text"
          [card]="m.card"
          [responseId]="m.responseId"
          [usage]="m.usage"
          [actionsActive]="m === messages[messages.length - 1]"
          (openEntity)="onOpenEntity($event)"
          (action)="onAction($event)"
          (feedback)="onFeedback($event)">
        </nova-card>
      </div>
    </div>

    <!-- Typing indicator -->
    <div class="chat-msg nova" *ngIf="isSending" [attr.aria-label]="'NOVA_TYPING' | translate">
      <div class="msg-avatar" aria-hidden="true">
        <ion-icon name="sparkles"></ion-icon>
      </div>
      <div class="msg-bubble typing" aria-hidden="true">
        <span></span><span></span><span></span>
      </div>
    </div>
  </div>

  <nova-mic-input
    class="chat-input-area"
    [isSending]="isSending"
    [isOffline]="isOffline"
    [attachments]="attachments"
    (sendMessage)="onMicSend($event)"
    (voiceError)="onMicError($event)"
    (attachClick)="attachClick.emit()"
    (removeAttachment)="removeAttachment.emit($event)">
  </nova-mic-input>
</div>
